export default {
  message: (state) => state.message,
  errors: (state) => state.errors ?? [],
  success: (state) => state.success,
  forget_phone: (state) => state.forget_phone,
};
